import geoRepository from '../repositories/geoRepository'

export const getGeo = () => geoRepository()

export default getGeo
